var _style, _g, _defs, _path, _polygon, _defs2, _path2, _polygon2, _defs3, _path3, _polygon3, _defs4, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _path4, _defs5, _polygon13, _path5, _ellipse, _path6, _polygon14, _polygon15, _path7, _path8, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGarlandGrill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#CCCCCC;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#808080;}\n\t.st5{clip-path:url(#SVGID_4_);fill:#CCCCCC;}\n\t.st6{clip-path:url(#SVGID_4_);fill:#808080;}\n\t.st7{clip-path:url(#SVGID_6_);fill:#CCCCCC;}\n\t.st8{clip-path:url(#SVGID_6_);fill:#808080;}\n\t.st9{clip-path:url(#SVGID_8_);fill:#808080;}\n\t.st10{fill:#CCCCCC;}\n\t.st11{fill:#808080;}\n\t.st12{opacity:0.5;fill:#FFFFFF;}\n\t.st13{fill:#0AAEFF;}\n\t.st14{fill:none;stroke:#4C4C4C;stroke-width:6;stroke-miterlimit:10;}\n\t.st15{clip-path:url(#SVGID_10_);fill:#CCCCCC;}\n\t.st16{fill:url(#SVGID_11_);}\n\t.st17{fill:#FFFFFF;}\n\t.st18{opacity:0.5;fill:#808080;}\n\t.st19{fill:#999999;}\n\t.st20{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st21{fill:#C7A969;}\n\t.st22{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n\t.st23{fill:#A68746;}\n\t.st24{fill:#D9BD82;}\n\t.st25{fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st26{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M176.1,459.8c2.2,0.5,4.5,0.4,6.7-0.8c6.4-3.2,10-12.8,8-21.3c-1.3-5.5-4.6-9.2-8.5-10.3 c-3.9-1.1-10.6-2.8-12.8-3.4c-2.1-0.6-4.5-0.4-6.8,0.7c-6.4,3.2-10,12.8-8,21.3c1.3,5.5,4.6,9.3,8.5,10.3 C166.4,457.2,172.7,459,176.1,459.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.6,449.4c-2-8.5,1.5-18.1,8-21.3c2.3-1.2,4.6-1.4,6.8-0.7c-3.9-1.1-10.6-2.8-12.8-3.4 c-2.1-0.6-4.5-0.4-6.8,0.7c-6.4,3.2-10,12.8-8,21.3c1.3,5.5,4.6,9.3,8.5,10.3c3.1,0.9,9.4,2.6,12.8,3.4 C172.2,458.7,168.9,454.9,167.6,449.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "146.9,430.3 175,438.1 193.2,431.3 184.9,417.5 147.8,419.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M234.9,475.5c2.2,0.5,4.5,0.4,6.7-0.8c6.4-3.2,10-12.8,8-21.3c-1.3-5.5-4.6-9.2-8.5-10.3 c-3.9-1.1-10.6-2.8-12.8-3.4c-2.1-0.6-4.5-0.4-6.8,0.7c-6.4,3.2-10,12.8-8,21.3c1.3,5.5,4.6,9.3,8.5,10.3 C225.3,473,231.5,474.8,234.9,475.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M226.4,465.2c-2-8.5,1.5-18.1,8-21.3c2.3-1.2,4.6-1.4,6.8-0.7c-3.9-1.1-10.6-2.8-12.8-3.4 c-2.1-0.6-4.5-0.4-6.8,0.7c-6.4,3.2-10,12.8-8,21.3c1.3,5.5,4.6,9.3,8.5,10.3c3.1,0.9,9.4,2.6,12.8,3.4 C231,474.4,227.7,470.7,226.4,465.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "208.2,445.8 236.3,453.6 254.5,446.9 246.2,433.1 209.1,435.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M330.3,420.3c2.2,0.5,4.5,0.4,6.7-0.8c6.4-3.2,10-12.8,8-21.3c-1.3-5.5-4.6-9.2-8.5-10.3 c-3.9-1.1-10.6-2.8-12.8-3.4s-4.5-0.4-6.8,0.7c-6.4,3.2-10,12.8-8,21.3c1.3,5.5,4.6,9.3,8.5,10.3 C320.6,417.8,326.9,419.6,330.3,420.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M321.7,410c-2-8.5,1.5-18.1,8-21.3c2.3-1.2,4.6-1.4,6.8-0.7c-3.9-1.1-10.6-2.8-12.8-3.4 c-2.1-0.6-4.5-0.4-6.8,0.7c-6.4,3.2-10,12.8-8,21.3c1.3,5.5,4.6,9.3,8.5,10.3c3.1,0.9,9.4,2.6,12.8,3.4 C326.3,419.3,323,415.5,321.7,410z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "305.3,414.2 328.7,401.7 349.4,398.5 341.8,380.3 304.7,382.3  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_7_",
    points: "135.9,283.1 135.9,212.5 141.4,165.9 259.1,98.9 259.1,212  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible",
      fill: "#999999"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "119.2,351.1 135.9,212.5 266.2,138.3 266.2,266.3  "
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "147.7,286.6 135.9,283.4 135.9,212.5 147.9,215.9  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "259.4,150.8 147.4,215.4 131,355.7 142.5,358.7 142.5,422.8 234.7,447.5 351.6,380 351.6,175.5  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "142.5,368.2 234.7,392.9 234.7,383.2 223.2,380.4 142.5,358.7  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "234.7,447.5 234.7,383.2 223.2,380.4 239.7,240.1 351.6,175.5 351.6,380  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "147.4,215.4 131,355.7 223.2,380.4 239.7,240.1  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "151.4,251.4 143.8,315.6 219.9,336 227.5,271.8  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "165.3,272.7 162,302 205.4,313.6 208.7,284.4  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "273,102.7 359.6,125.9 359.6,238.9 273,215.6  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M315.9,74.5c10-22.9,27.4-25.2,36.5-19.9c11.5,6.8,12.8,22.4,5.9,40.2c-8.1,20.7-15,57.5-15,88.7"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_9_",
    points: "147.4,215.4 239.7,240.1 351.6,175.5 259.4,150.8  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "343,187.8 369.5,169.9 266.7,140.6 231.5,158.4 217.2,175.2 293.9,175.2 308.8,179.2 197.5,243.4  289.7,268.2 401.7,203.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.2617,
    y1: 114.4945,
    x2: 298.2617,
    y2: 193.8955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M310.9,103.9c0-2.9-5.7-5.2-12.7-5.2c-7,0-12.7,2.3-12.7,5.2c0,1.3,0,64.7,0,66c0,2.9,5.7,5.2,12.7,5.2 c7,0,12.7-2.3,12.7-5.2C310.9,168.6,310.9,105.3,310.9,103.9z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 298.3,
    cy: 103.9,
    rx: 12.7,
    ry: 5.2
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M310.9,126.9c-2.6-2.8-7-5.9-13.3-6.5c-6.2-0.6-9.6,1.4-12,3.6V76h25L310.9,126.9z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "251.1,314.1 251.3,243.4 256.9,196.8 374.6,129.9 374.6,242.9  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "251.1,314.1 239.3,311 239.3,240.1 251.3,243.4  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M244.1,293.7l-2.3,1.4c-1.8,1.1-4.1-0.2-4.1-2.3v-26.4c0-2.4,1.3-4.6,3.3-5.7l3.1-1.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M141.9,266.3l-2.3,1.4c-1.8,1.1-4.1-0.2-4.1-2.3V239c0-2.4,1.3-4.6,3.3-5.7l3.1-1.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "188.2,23.1 266.7,44.1 344.2,83.4 334.5,105.9 255.8,85.2 178.4,45.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "257,66.7 334.5,105.9 255.8,85.2 178.4,45.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "257,66.7 266.7,44.1 188.2,23.1 178.4,45.6  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M246.7,62.9l3.2-7.3c2-4.6-0.6-10-5.5-11.3l-61.3-16.4c-4-1.1-8.1,0.9-9.8,4.7l-4.2,9.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "164.8,36.4 253.7,60.3 341.6,104.8 333.5,123.3 244.4,99.8 156.7,55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "245.7,78.8 333.5,123.3 244.4,99.8 156.7,55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "245.7,78.8 253.7,60.3 164.8,36.4 156.7,55  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "H",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -159.8,
    y1: 405.3,
    x2: 507.8,
    y2: 19.9
  })), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 163.6,
    y1: -79.7,
    x2: 163.6,
    y2: 616.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 250.2,
    y1: -23.1,
    x2: 250.2,
    y2: 673.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 344.6,
    y1: -28,
    x2: 344.6,
    y2: 668.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 99,
    y1: 494.6,
    x2: 766.6,
    y2: 109.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 99,
    y1: 521,
    x2: 766.6,
    y2: 135.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -84.7,
    y1: 427.8,
    x2: 582.8,
    y2: 42.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -159.8,
    y1: 371.9,
    x2: 507.8,
    y2: -13.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -87.9,
    y1: 393.9,
    x2: 579.7,
    y2: 8.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -1030.9,
    y1: 67.7,
    x2: 809.4,
    y2: 560.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -858.9,
    y1: -233.5,
    x2: 981.4,
    y2: 259.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -860.5,
    y1: -216.4,
    x2: 979.7,
    y2: 276.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -857.4,
    y1: -213.7,
    x2: 982.8,
    y2: 279.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -864.4,
    y1: -189.2,
    x2: 975.8,
    y2: 303.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -816.6,
    y1: 7.2,
    x2: 1023.6,
    y2: 500.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -913.2,
    y1: 44.9,
    x2: 927.1,
    y2: 538
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -931,
    y1: 48.3,
    x2: 909.2,
    y2: 541.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -1038,
    y1: 69.9,
    x2: 802.2,
    y2: 563
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 37.7,
    y1: 475.6,
    x2: 705.2,
    y2: 90.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -57.4,
    y1: 464.6,
    x2: 610.2,
    y2: 79.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 192,
    y1: 32,
    x2: 171.1,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 266.7,
    y1: 53.2,
    x2: 245.8,
    y2: 101.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 273.2,
    y1: 72.7,
    x2: 252.3,
    y2: 120.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 340.3,
    y1: 81.8,
    x2: 319.4,
    y2: 129.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -825.3,
    y1: -38.7,
    x2: 1014.9,
    y2: 454.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarlandGrill);
export default __webpack_public_path__ + "static/media/garlandGrill.0084e649a691d2cd5a75f631313154e8.svg";
export { ForwardRef as ReactComponent };